import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { withRouter } from "react-router";
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import routes from '../../routes';
import DefaultHeader from '../defaultHeader/DefaultHeader';
import DefaultFooter from '../defaultFooter/DefaultFooter';
import IdleTimer from 'react-idle-timer';
import PopupDialog from '../../components/popupDialog/PopupDialog';

class DefaultLayout extends Component {

    constructor(props) {
        super(props);

        this.idleTimer = null
        this.LogoutTime = window.seessionTimeout

        this.state = {
            routes1: routes,
            remaining: this.LogoutTime,
            elapsed: 0,
            isIdle: false,
            lastActive: new Date(),
            isPopupOpen: false,
            timeoutRunning: false
        }

        this.handleOnIdle = this.handleOnIdle.bind(this);
    }

    componentDidMount() {
        if (this.idleTimer) {
            this.setState({
                remaining: this.idleTimer.getRemainingTime(),
                lastActive: this.idleTimer.getLastActiveTime(),
                elapsed: this.idleTimer.getElapsedTime(),
                leader: this.idleTimer.isLeader(),
                isIdle: this.idleTimer.isIdle()
            })
        }

        setInterval(() => {
            if (this.state.remaining < 60000 && !this.state.isPopupOpen) {

                this.setState({ isPopupOpen: true });

                this.setState({ showModal: true, popupMessage: window.sessionTimeoutMsg, popupTitle: "Confirmation Required" }, () => {
                    this.timeout = setTimeout(() => {
                        this.setState({ showModal: false });
                    }, 300000) // 5 min
                });
            }

            if (this.idleTimer) {
                this.setState({
                    timeoutRunning: true,
                    remaining: this.idleTimer.getRemainingTime(),
                    lastActive: this.idleTimer.getLastActiveTime(),
                    elapsed: this.idleTimer.getElapsedTime(),
                    leader: this.idleTimer.isLeader(),
                    isIdle: this.idleTimer.isIdle()
                })
            }

        }, 1000)
    }

    logout = () => {
        sessionStorage.clear();
        this.props.history.push('/');
    }

    handleOnIdle = () => {
        this.logout();
    }

    sessionTimeoutSubmit = (result) => {
        let me = this;

        this.setState({ showModal: false });
        clearInterval(this.timeout);

        if (result === "continue") {
            //continue working
            this.setState({ showModal: false, remaining: this.idleTimer.getRemainingTime() }, () => {
                me.idleTimer.reset();
            });

        } else {
            this.setState({ showModal: false, remaining: this.idleTimer.getRemainingTime() }, () => {
                this.logout();
            });
        }
    }

    handleModal = () => {
        let showModal = this.state.showModal
        this.setState({ showModal: !showModal });
        if (showModal && this.timeout) clearInterval(this.timeout);
    }

    render() {
        const { routes1, popupTitle, popupMessage, showModal } = this.state;
        let loc = window.location.hash;
        return (
            <Container fluid >

                {loc !== '#/' && <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    timeout={this.LogoutTime}
                    onIdle={this.handleOnIdle}
                    debounce={250}
                />}

                <Switch>
                    {routes1.map((route, idx) => {

                        return route.component ? (

                            <Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                                <>
                                    {/* Header */}
                                    {route.name === "" || route.name === "login" || route.name === "PurchaseOrders" || route.name === "Claims" ? null : <div className="header"><DefaultHeader /></div>}

                                    {/* body */}
                                    <route.component {...props} />

                                    {/* Footer */}
                                    {route.name === "" || route.name === "login" || route.name === "PurchaseOrders" || route.name === "Claims" ? null : <div className="footer"><DefaultFooter /></div>}
                                </>
                            )} />

                        )
                            : (null);
                    },
                    )}
                    <Redirect from="/" to="/404" />
                </Switch>

                {showModal ? <PopupDialog
                    showModal={showModal}
                    handleModal={this.handleModal}
                    title={popupTitle}
                    message={popupMessage}
                    confirmBtn={true}
                    sessionTimeoutSubmit={(val) => this.sessionTimeoutSubmit(val)}
                /> : ''}
            </Container>
        )
    }

}

var DefaultLayoutModule = connect(null)(withRouter(DefaultLayout));
export default DefaultLayoutModule;